<template>
  <!-- 企业微信自建应用主页：免密登录后进入工作台 -->
  <div class="defaultViewStyle">
    <div class="login-panel">
      <div class="login-tip">{{ loginTip }}</div>
    </div>
  </div>
</template>

<script>
import {useRoute, useRouter} from "vue-router";
import baseApi from "@/api/baseApi";
import util from "@/util/util";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "QywxSelfLogin",
  components: {},
  data() {
    return {
      loginTip: "正在登录。。。"
    };
  },
  created() {
    this.loginByCode();
  },
  methods: {
    /**
     * 自建应用免密登录。
     *
     * 企业微信会把 code 拼在应用主页地址上回调回来，
     * 商户id 是配置应用主页时带上的（换 accessToken 要用该商户的 corpId+secret）。
     */
    async loginByCode() {
      const code = this.route.query.code;
      const merchantId = this.resolveMerchantId();
      if (!code || !merchantId) {
        // 没有code说明不是从企业微信进入的，直接去手动登录
        this.toLoginPage();
        return;
      }
      try {
        // 企业微信 PC / 移动端分别签发 token：同端互斥、不同端可同时在线
        const clientType = util.getContextPath() === 3 ? "QYWX_MOBILE" : "QYWX_PC";
        const user = await baseApi.loginByQywxSelfCode(merchantId, code, clientType);
        util.clearCacheData(); // 清空缓存
        util.setUserInfo(user); // 设置登录信息
        // 会话过期是会被清空的（axios 里 clearSession 清掉了商户id），
        // 这里补回去：再次过期时仍然走本商户的自建应用授权，而不是退回 saas 那套
        util.setQywxMerchantId(merchantId);
        this.toMainPage();
      } catch (e) {
        // 找不到职员、code失效等，都走手动登录
        this.toLoginPage();
      }
    },
    /**
     * 解析商户id。
     *
     * 应用主页是 OAuth 链接，商户id放在 state 里透传 —— 不挂在 redirect_uri 上是因为
     * redirect_uri 本身要 encodeURIComponent，再嵌一层 query 会被双重编码。
     * 所以 state 不以 "/" 开头时按商户id处理；以 "/" 开头的是登录后的回跳地址（见 toMainPage）。
     */
    resolveMerchantId() {
      const merchantId = this.route.query.merchantId;
      if (merchantId) {
        return merchantId;
      }
      const state = this.route.query.state;
      return (state && !state.startsWith("/")) ? state : "";
    },
    /**
     * 登录成功后去哪。
     *
     * 优先回登录前那一页：企业微信消息把人带到某个单据上，被登录拦下来后
     * 直接丢回工作台，等于让他重新从消息里再点一次。
     * 只有工作台打开应用主页（storage 里没有记录）时，才按原逻辑回主页。
     */
    toMainPage() {
      // ★ 全部用 replace：企业微信回调的 code 是一次性的，
      //   登录页不能留在历史记录里，否则浏览器回退会回到带 code 的登录页并二次消费报错。
      const backUrl = util.getQywxBackUrl();
      if (backUrl) {
        // 用完即清：留着的话，下次从工作台进来也会被跳回一个早已过期的页面
        util.clearQywxBackUrl();
        this.router.replace(backUrl);
        return;
      }
      const state = this.route.query.state;
      if (state && state.startsWith("/")) {
        this.router.replace(state);
        return;
      }
      // context：2 企业微信PC端，3 企业微信移动端
      const context = util.getContextPath();
      if (context === 2) { // 企业微信PC端
        this.router.replace(`/welcome`);
      } else if (context === 3) { // 企业微信移动端
        this.router.replace(`/qywx/home`);
      } else {
        // 非企业微信环境，按窗口宽度兜底
        this.router.replace(window.innerWidth < 1024 ? `/qywx/home` : `/welcome`);
      }
    },
    /** 登录失败，跳手动登录页 */
    toLoginPage() {
      this.loginTip = "自动登录失败，正在跳转登录页。。。";
      // 同样用 replace：登录失败页也不应该被回退回来
      this.router.replace(`/login`);
    }
  }
};
</script>

<style lang="scss" scoped>
.defaultViewStyle {
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  .login-panel {
    width: 100%;
    text-align: center;
    .login-tip {
      color: #909399;
      font-size: 14px;
    }
  }
}
</style>
